import { render, staticRenderFns } from "./SearchText.vue?vue&type=template&id=6e809a58&scoped=true&"
import script from "./SearchText.vue?vue&type=script&lang=js&"
export * from "./SearchText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e809a58",
  null
  
)

export default component.exports